//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { parse } from "node-html-parser";
import { sanitize } from "string-sanitizer";

export default {
  props: {
    content: {
      required: true,
    },
  },
};
